enum SuggestedProductTypes {
  minimumAmount = 1,
  products = 2,
}

export default SuggestedProductTypes;
